/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_F_Text1Inputs */

const vi_sitesettings_f_text1 = /** @type {(inputs: Sitesettings_F_Text1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả ngắn`)
};

/**

* @param {Sitesettings_F_Text1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_f_text1 = /** @type {((inputs?: Sitesettings_F_Text1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_F_Text1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_f_text1(inputs)
});
export { sitesettings_f_text1 as "siteSettings_f_text" }